import { USER_ROLES } from "./constants";

const restaurantColumns = [
    {
        title: "_restaurant_name_",
        key: "name",
        format: "name",
        isNested: false,
        isKey: false,
        dataSort: true,
    },
    {
        title: "_restaurant_id_",
        key: "restaurantIndex",
        format: "restaurantId",
        isNested: false,
        isKey: true,
        dataSort: true,
    },
    {
        title: "_legal_person_name_",
        key: "legalPersonName",
        format: "legalPersonName",
        isNested: false,
        isKey: false,
        dataSort: true,
    },
    {
        title: "_taxpayer_identification_number_",
        key: "taxpayerIdentificationNumber",
        format: "taxpayerIdentificationNumber",
        isNested: false,
        isKey: false,
        dataSort: true,
    },
    {
        title: "_account_number_",
        key: "accountNumber",
        format: "accountNumber",
        isNested: false,
        isKey: false,
        dataSort: true,
    },
    {
        title: "_restaurant_address_",
        key: "restaurantInformation.location.address",
        format: "location.address",
        isNested: true,
        isKey: false,
        dataSort: false,
    },
    {
        title: "_restaurant_phone_",
        key: "restaurantInformation.phoneNumbers",
        format: "phoneNumbers",
        isNested: true,
        isKey: false,
        dataSort: false,
    },
    {
        title: "_payment_type_",
        key: "cooperationType",
        format: "cooperationType",
        isNested: false,
        isKey: false,
        dataSort: false,
    },
    {
        title: "_customer_percentage_",
        key: "customerPercentage",
        format: "percentage",
        isNested: false,
        isKey: false,
        dataSort: false,
    },
    {
        title: "_restaurant_percentage_",
        key: "restaurantPercentage",
        format: "percentage",
        isNested: false,
        isKey: false,
        dataSort: false,
    },
    {
        title: "_cooperation_type_",
        key: "cooperationType.sourceOfIncome",
        format: "sourceOfIncome",
        isNested: true,
        isKey: false,
        dataSort: false,
    },
    {
        title: "_partner_type_",
        key: "type",
        format: "type",
        isNested: false,
        isKey: false,
        dataSort: false,
    },
    {
        title: "_applicable_delivery_time_",
        key: "applicableDeliveryTime",
        format: "applicableDeliveryTime",
        isNested: false,
        isKey: false,
        dataSort: false,
    },
    {
        title: "_auto_send_to_supplier_",
        key: "autoSendToPartner",
        format: "autoSendToPartner",
        isNested: false,
        isKey: false,
        dataSort: false,
    },
    {
        title: "_is_transaction_type_",
        key: "isTransactionType",
        format: "isTransactionType",
        isNested: false,
        isKey: false,
        dataSort: false,
    },
    {
        title: "_finance_infos_",
        key: "cooperationType",
        format: "financeInfos",
        isNested: false,
        isKey: false,
        dataSort: false,
    },
    {
        title: "Հարկման ռեժիմ",
        key: "taxRegime",
        format: "taxRegime",
        isNested: false,
        isKey: false,
        dataSort: true,
    },
    {
        title: "ՀԴՄ գրանցման համարը (CRN)",
        key: "crn",
        isNested: false,
        isKey: false,
        dataSort: true,
    },
    {
        title: "ՀԴՄ գործարանային համար (SN)",
        key: "sn",
        isNested: false,
        isKey: false,
        dataSort: true,
    },
    {
        title: "ՀԴՄ բաժնի համար",
        key: "dep",
        isNested: false,
        isKey: false,
        dataSort: true,
    },
    {
        title: "Գանձապահի համար",
        key: "cashierId",
        isNested: false,
        isKey: false,
        dataSort: true,
    },
];

export default {
    restaurant: {
        [USER_ROLES.MANAGER]: [0, 1, 5, 6, 7, 8, 9, 10, 11, 15],
        [USER_ROLES.CALL_CENTER]: [0, 1, 5, 6, 7, 8, 9, 10, 11],
        [USER_ROLES.ORDER_MANAGER]: [0, 1, 5, 6, 7, 8, 9, 10, 11],
        [USER_ROLES.ADMIN]: [0, 1, 5, 6, 7, 8, 9, 10, 11, 15, 16, 17, 18, 19, 20],
        [USER_ROLES.PARTNER_MANAGER]: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 16, 17, 18, 19, 20],
        [USER_ROLES.SUPER_ADMIN]: [0, 1, 5, 6, 7, 8, 9, 10, 11, 15, 16, 17, 18, 19, 20],
    },
    branch: [
        {
            title: "_branch_name_",
            key: "name",
            isKey: true,
            dataSort: true,
        },
        {
            title: "_restaurant_address_",
            key: "restaurantInformation.location.address",
            format: "location.address",
            isNested: true,
            isKey: false,
            dataSort: true,
        },
        {
            title: "_restaurant_phone_",
            key: "restaurantInformation.phoneNumbers",
            format: "phoneNumbers",
            isNested: true,
            isKey: false,
            dataSort: true,
        },
        {
            title: "_holidays_",
            key: "restaurantInformation.holidays",
            format: "holidays",
            isNested: true,
            isKey: false,
            dataSort: true,
        },
        {
            title: "_working_hours_",
            key: "restaurantInformation.workingHours",
            format: "workingHours",
            isNested: true,
            isKey: false,
            dataSort: true,
        },
        {
            title: "_non_working_days_",
            key: "restaurantInformation.nonWorkingDays",
            format: "nonWorkingDays",
            isNested: true,
            isKey: false,
            dataSort: true,
        },
        {
            title: "_is_from_back_entrance_",
            key: "restaurantInformation.isFromBackEntrance",
            format: "isFromBackEntrance",
            isNested: true,
            isKey: false,
            dataSort: true,
        },
    ],
    restaurantEdit: [
        "name",
        "nameRu",
        "nameEn",
        "restaurantId",
        "nRestaurantId",
        "restaurantIndex",
        "legalPersonName",
        "taxpayerIdentificationNumber",
        "bankName",
        "accountNumber",
        "notificationEmails",
        "telegramChannelId",
        "location",
        "phoneNumbers",
        "cooperationType",
        "printHdmForSupplier",
        "customerPercentage",
        "restaurantPercentage",
        "restaurantInformation",
        "specialHintType",
        "branches",
        "specialHintType",
        "includeNetPriceInNotification",
        "type",
        "applicableDeliveryTime",
        "autoSendToPartner",
        "isTransactionType",
        "email",
        // "hasCertificate",
        "sendMail",
        "company",
        "isSendToHaysell",
        "partnerLegalAddress",
        "directorFullName",
        "aahSaler",
        "includeNetPriceInNotification",
        "passportRequired",
        "isDeliveryServiceProvision",
        "supplierDeliveryTariff",
        "supplierDeliveryTariff2nd",
        "preparationAverageTime",
        "deliveryAverageTime",
        "paymentOption",
        "isIntegrationSupplierSystem",
        "b2bHintType",
        "productManagement",
        "invoiceIssuanceType",
        "taxRegime",
        "crn",
        "sn",
        "dep",
        "cashierId",
        "notifyPrincipalAccount",
    ],
    validations: {
        name: {
            required: true,
            validations: {
                minLength: 2,
            },
            validationErrors: {
                minLength: "_restaurant_name_min_error_",
            },
        },
        restaurantId: {
            required: true,
        },
        nRestaurantId: {
            required: true,
        },
        legalPersonName: {
            required: true,
        },
        partnerLegalAddress: {
            required: false,
        },
        directorFullName: {
            required: false,
        },
        bankName: {
            required: false,
        },
        invoiceIssuanceType: {
            required: false,
        },
        taxpayerIdentificationNumber: {
            required: true,
            validations: {
                matchRegexp: /^\d+$/,
            },
            validationErrors: {
                matchRegexp: "_only_number_error_",
            },
        },
        accountNumber: {
            required: true,
            validations: {
                matchRegexp: /^\d+$/,
            },
            validationErrors: {
                matchRegexp: "_only_number_error_",
            },
        },
        phoneNumbers: {
            required: true,
            validations: {
                matchRegexp: /^\+?\d+$/,
            },
            validationErrors: {
                matchRegexp: "_phone_numbers_error_",
            },
        },
        address: {
            required: false,
        },
        paymentPeriod: {
            required: true,
            validations: {
                matchRegexp: /^\d+$/,
            },
            validationErrors: {
                matchRegexp: "_only_number_error_",
            },
        },
        applicableDeliveryTime: {
            required: false,
            validations: {
                matchRegexp: /^\d+$/,
            },
            validationErrors: {
                matchRegexp: "_only_number_error_",
            },
        },
        email: {
            required: false,
            validations: {
                isEmail: true,
                minLength: 6,
                maxLength: 64,
                matchRegexp: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
            },
            validationErrors: {
                isEmail: "_email_format_error_",
                minLength: "_email_min_max_error_",
                maxLength: "_email_min_max_error_",
                matchRegexp: "_email_validation_error_",
            },
        },
        telegramChannelId: {
            required: false,
        },
        notificationEmails: {
            required: false,
            validations: {
                matchRegexp:
                    /^(\s*[\w-.]+@([\w-]+\.)+[\w-]{2,4}\s*)(;\s*[\w-.]+@([\w-]+\.)+[\w-]{2,4}\s*)*$/,
            },
            validationErrors: {
                matchRegexp: "_email_validation_error_",
            },
        },
        haysellRegion: {
            required: false,
            validations: {
                matchRegexp: /^\d+$/,
            },
            validationErrors: {
                matchRegexp: "_only_number_error_",
            },
        },
        preparationAverageTime: {
            required: true,
        },
        deliveryAverageTime: {
            required: true,
        },
        paymentOption: {
            required: true,
        },
        branchKey: {
            required: false,
        },
    },
    canEdit(role) {
        return (
            role === USER_ROLES.ADMIN ||
            role === USER_ROLES.SUPER_ADMIN ||
            role === USER_ROLES.PARTNER_MANAGER
        );
    },
    getColumns(role) {
        const list = [];
        let columns = this.restaurant[role] || [];
        for (let i = 0, length = columns.length; i < length; i++) {
            list.push(restaurantColumns[columns[i]]);
        }
        return list;
    },
};
